// extracted by mini-css-extract-plugin
module.exports = {"desktop_bar":"DesktopBar_desktop_bar__qR75q","desktop_bar__button":"DesktopBar_desktop_bar__button__3opqn"};